import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const CheckSection = ({ className, label, name, value, error, onChange }) => (
  <div className={`col-xs-12  padding-top-1 ${className}`}>
    <p>
      <label className="my-account__checkbox">
        <input
          type="checkbox"
          id={name}
          name={name}
          checked={value}
          onChange={onChange}
        />
        <span className="check-show check-icon" />
        {label}
        {error && (
          <>
            <span className="input-group-addon error-icon">
              <i className="fa fa-exclamation-triangle" />
            </span>
          </>
        )}
      </label>
    </p>
  </div>
);

CheckSection.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.number,
  error: PropTypes.string,
  onChange: PropTypes.func,
};

export default CheckSection;
